import { Translate } from "../translate";
import { getStore } from "../utils/global";

const Dock = (props) => {
  let { p } = props;
  let key = p.main;
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  return <div className="main_dock">{Translate[ln].Main[key]}</div>;
};

export default Dock;
